<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	import { translateTemplateTitle } from 'src/helpers/xt1_helpers/template_helpers';
	// Design system components
	import { Text } from '@Shelly/shelly-design-system';
	import type { TextPropsTypes } from '@Shelly/shelly-design-system';

	let className = '';
	export { className as class };
	export let title: string,
		style: string = '',
		styleType: TextPropsTypes['styleType'] = 'h2';
</script>

<Text {styleType} {style} class={className} noWrap>
	{$format(`collapse_title_chart_${(title || '').toLowerCase().replace(/\s+/g, '_')}`, {
		default: translateTemplateTitle(title),
	})}
</Text>
